module.exports = __webpack_public_path__ + "static/media/plus_with_circle_icon.68bfc291.svg";